class BundleBuilder {
    constructor(container) { 
      this.container = container;
      this.state = {};
      this.context = container.dataset.context || 'pdp';
      this.bundleName = container.dataset.bundleName || 'bundle';
      this.isSubscription = false;
      this.subscriptionDiscount = 0.10;
      this.sellingPlanId = window.SUBSCRIPTION_PLAN_ID || null;
      this.maxBundleQty = 6;
      this.tiers = [
        {
          qty: Number(container.dataset.bundleTier1Qty) || 2,
          discount: Number(container.dataset.bundleTier1Discount) || 15
        },
        {
          qty: Number(container.dataset.bundleTier2Qty) || 3,
          discount: Number(container.dataset.bundleTier2Discount) || 20
        }
      ];
      this.form = this.getForm();
      this.atc = this.getATC();
      this.init();
    }

    init() {
      if (!this.container) return;

      if(this.context === 'pdp') {
        this.bindVariantTrigger();
      }
      this.bindQty();
      this.bindATC();
      this.updateUI();
      this.bindSubscriptionSelector();
    }

    getForm() {
      if (this.context === 'pdp') {
        return this.container.closest('.product__info-container').querySelector('form[action="/cart/add"]');
      }
      return null;
    }

    getATC() {
      if (this.context === 'pdp') {
        return this.container.closest('.product__info-container').querySelector('.product-form__buttons [data-bundle-atc]');
      }

      return this.container.querySelector('[data-bundle-atc]');
    }

    // Variant selector
    bindVariantTrigger() {
      const bundleBtn = document.querySelector('[data-bundle-trigger]');
      const variantBtns = document.querySelectorAll('.product-variant__item--radio');
      const stickyBar = document.querySelector(".product-sticky-add-bar");

      if (!bundleBtn) return;

      bundleBtn.addEventListener('click', () => {
        this.container.classList.add('show');
        document.body.classList.add('bundle-active');
        this.updateUI();
        if (stickyBar) {
          stickyBar.querySelector('.product-sticky-add-bar__title').innerHTML = bundleBtn.querySelector('input').getAttribute('aria-label');
        }
      });

      variantBtns.forEach(btn => {
        if (btn === bundleBtn) return;
        btn.addEventListener('click', () => {
          const wasBundleActive = document.body.classList.contains('bundle-active');
          this.container.classList.remove('show');
          document.body.classList.remove('bundle-active');
          this.resetBundle();
          if (wasBundleActive) {
            requestAnimationFrame(() => {
              window.SubscriptionManager?.updatePrices();
            });
          }
          if (stickyBar) {
            stickyBar.querySelector('.product-sticky-add-bar__title').innerHTML = btn.querySelector('input').getAttribute('aria-label');
          }
        });

      });
    }


    bindSubscriptionSelector() {
      if (this.context !== 'pdp') return;
      const radios = this.container.closest('.product').querySelectorAll('input[name="purchase_type"]');
      radios.forEach(radio => {

        radio.addEventListener('change', () => {
          this.isSubscription = radio.value === 'subscription';

          this.updateUI();
        });
      });
    }

    // Quantity
    bindQty() {
      this.container.addEventListener('input', e => {
        const input = e.target.closest('input[name="bundle-qty"]');
        if (!input) return;
        const item = input.closest('.bundle-item');
        const id = item.dataset.variantId;
        const otherQty = this.getTotalQty() - (this.state[id] || 0);
        const qty = Math.min(this.maxBundleQty - otherQty, Math.max(0, Math.floor(Number(input.value) || 0)));
        input.value = qty;
        this.state[id] = qty;
        this.updateUI();
      });
      this.container.addEventListener('click', e => {
        const item = e.target.closest('.bundle-item');
        if (!item) return;
        const input = item.querySelector('input');
        let qty = Number(input.value);
        const currentTotalQty = this.getTotalQty();
        if (e.target.matches('[data-plus]')) {
          if (currentTotalQty >= this.maxBundleQty) {
            const warning = this.container.querySelector('[data-bundle-warning]');
            if (warning) {
              warning.innerText = `Maximum ${this.maxBundleQty} items allowed`;
              warning.hidden = false;
              clearTimeout(this.warningTimeout);
              this.warningTimeout = setTimeout(() => {
                warning.hidden = true;
              }, 3000);
            }
            return;
          }
          qty++;
        }
        if (e.target.matches('[data-minus]')) {
          qty = Math.max(0, qty - 1);
        }
        input.value = qty;
        const id = item.dataset.variantId;
        this.state[id] = qty;
        this.updateUI();
      });
    }

    // Total quantity
    getTotalQty() {
      return Object.values(this.state).reduce((a, b) => a + b, 0);
    }

    // Reset bundle
    resetBundle() {
      this.state = {};
      this.container.querySelectorAll('input').forEach(input => {
        input.value = 0;
      });
      this.updateUI();
    }

    // Discount logic
    getDiscountRate(totalQty) {
      let discount = 0;
      this.tiers.forEach(tier => {
        if (totalQty >= tier.qty) {
          discount = tier.discount;
        }
      });
      return discount / 100;
    }

    // Next tier message
    getNextTierMessage(totalQty) {
      const nextTier = this.tiers.find(t => totalQty < t.qty);
      if (!nextTier) return '';
      const diff = nextTier.qty - totalQty;
      return `You’re ${diff} item${diff > 1 ? 's' : ''} away from ${nextTier.discount}% off`;
    }

    updateMainPrices(totalPrice, comparePrice) {
      const regularEls = document.querySelectorAll('.product .price--regular, .product-sticky-add-bar .price--regular');
      const compareEls = document.querySelectorAll('.product .price--compare, .product-sticky-add-bar .price--compare');

      regularEls.forEach(el => {
        el.innerHTML = totalPrice ? formatMoney(totalPrice, '') : this.container.dataset.chooseLabel;
      });

      compareEls.forEach(el => {
        if (comparePrice > totalPrice) {
          el.innerHTML = formatMoney(comparePrice, '');
          el.classList.remove('hidden');
        } else {
          el.innerHTML = '';
          el.classList.add('hidden');
        }
      });
    }

    // UI update
    async updateUI() {
      const summary = this.container.querySelector('.bundle-summary');

      let totalQty = 0;
      let totalPrice = 0;
      let totalComparePrice = 0;

      this.container.querySelectorAll('.bundle-item').forEach(item => {
        const qty = Number(item.querySelector('input').value);
        const basePrice = Number(item.dataset.price);
        let finalPrice = basePrice;
        if (this.isSubscription) {
          finalPrice = Math.round(
            basePrice * (1 - this.subscriptionDiscount)
          );
        }

        totalPrice += qty * finalPrice;
        totalComparePrice += qty * basePrice;
        totalQty += qty;
      });

      const discount = this.getDiscountRate(totalQty);
      const discountedTotal = Math.round(totalPrice * (1 - discount));
      const discountedCompare = Math.round(totalComparePrice);

      const isBundleActive = document.body.classList.contains('bundle-active');
      if (isBundleActive && this.context === 'pdp') {
        this.updateMainPrices(discountedTotal, discountedCompare);
      }

      // animate
      summary?.classList.add('is-updating');
      const formatted = formatMoney(discountedTotal, "");

      setTimeout(() => {
        const totalEl = this.container.querySelector('[data-bundle-total]');
        if (totalEl) totalEl.innerHTML = formatted;

        const isBundle = document.body.classList.contains('bundle-active');
       // if (isBundle && this.context === 'pdp') document.querySelector('.button__price').innerHTML = ' - ' + formatted;

        summary?.classList.remove('is-updating');
      }, 120);

      const progressEl = this.container.querySelector('[data-bundle-progress]');
      if (progressEl) {
        const percent = this.getProgressPercent(totalQty);
        progressEl.style.width = percent + '%';
      }

      const tier1 = this.tiers[0];
      const tier2 = this.tiers[1];
      if (this.atc && this.context === 'pdp') {
        this.atc.disabled = totalQty < tier1.qty;
        this.atc.setAttribute('aria-disabled', String(totalQty < tier1.qty));
      }

      const label1 = this.container.querySelector('[data-tier-1-label]');
      const label2 = this.container.querySelector('[data-tier-2-label]');

      if (label1) {
        label1.innerText = `${tier1.qty} items (${tier1.discount}%)`;
      }

      if (label2) {
        label2.innerText = `${tier2.qty} items (${tier2.discount}%)`;
      }

      const messageEl = this.container.querySelector('[data-bundle-message]');

      if (messageEl) {
        const message = this.getBundleMessage(totalQty);

        messageEl.innerText = message;
        messageEl.hidden = !message;
      }

      // Handle Sticky ATC
      const stickyBarATC = document.querySelector(".product-sticky-add-bar .bundle-atc-anchor");
      if (stickyBarATC && this.context === 'pdp') {
        if (totalQty < tier1.qty) {
          stickyBarATC.classList.add('atc-disabled');
          stickyBarATC.querySelector('.button__label').innerHTML = 'Build a Bundle';
          stickyBarATC.querySelector('.button__label').dataset.label = 'Build a Bundle';
        } else {
          stickyBarATC.classList.remove('atc-disabled');
          stickyBarATC.querySelector('.button__label').innerHTML = 'Add to Cart';
          stickyBarATC.querySelector('.button__label').dataset.label = 'Add to Cart';
        }
      }

    }

    getProgressPercent(totalQty) {
      const tiers = [...this.tiers].sort((a, b) => a.qty - b.qty);
      const maxQty = tiers[tiers.length - 1].qty;

      const percent = Math.min((totalQty / maxQty) * 100, 100);

      return percent;
    }

    getBundleMessage(totalQty) {
      const tiers = [...this.tiers].sort((a, b) => a.qty - b.qty);

      const tier1 = tiers[0];
      const tier2 = tiers[1];

      // before tier 1
      if (totalQty < tier1.qty) {
        const diff = tier1.qty - totalQty;
        return `Add ${diff} more item${diff > 1 ? 's' : ''} to get ${tier1.discount}% off`;
      }

      // after tier 1, before tier 2
      if (totalQty >= tier1.qty && totalQty < tier2.qty) {
        const diff = tier2.qty - totalQty;
        return `${tier1.discount}% off unlocked. Add ${diff} more item${diff > 1 ? 's' : ''} to get ${tier2.discount}% off`;
      }

      // after tier 2
      return `${tier2.discount}% off applied — best deal unlocked`;
    }

    // Multi-ATC
    bindATC() {
      const btn = this.getATC();
      if (btn) {
        btn.addEventListener('click', async (e) => {
            e.preventDefault();
            if (btn.classList.contains('loading')) return;

            const totalQty = this.getTotalQty();
            const minQty = this.tiers[0].qty;

            const warning = this.container.querySelector('[data-bundle-warning]');

            if (totalQty < minQty) {
                if (warning) {
                warning.innerText = `Please select at least ${minQty} items`;
                warning.hidden = false;

                clearTimeout(this.warningTimeout);
                this.warningTimeout = setTimeout(() => {
                    warning.hidden = true;
                }, 5000);
                }
                return false;
            }

            
            const btnSpinner = btn.querySelector(".loading-overlay__spinner");
            btn.classList.add("loading");
            btn.setAttribute("aria-disabled", true);
            if (btnSpinner) btnSpinner.classList.remove("hidden");


            if (warning) warning.hidden = true;

            const timestamp = Date.now();
            const items = [];

            Object.entries(this.state).forEach(([id, qty]) => {
                if (!qty) return;

                const itemPayload = {
                  id: Number(id),
                  quantity: qty,
                  properties: {
                    _bundle: 'true',
                    _bundle_name: this.bundleName,
                    _bundle_id: timestamp
                  }
                };

                if (
                  this.isSubscription &&
                  this.sellingPlanId
                ) {
                  itemPayload.selling_plan =
                    this.sellingPlanId;
                }
                items.push(itemPayload);

            });

            try {
                const addRes = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items })
                });

                if (!addRes.ok) {
                const errText = await addRes.text();
                throw new Error(errText);
                }

                await updateCartUI();

                btn.classList.remove("loading");
                btn.setAttribute("aria-disabled", false);
                if (btnSpinner) btnSpinner.classList.add("hidden");

                return true;

            } catch (err) {
                console.error('Bundle add error:', err);
                btn.classList.remove("loading");
                btn.setAttribute("aria-disabled", false);
                if (btnSpinner) btnSpinner.classList.add("hidden");
                return false;
            }
        });
      }
    }


    // Subscription app (waiting for the app - subscription plan)
    getSellingPlan(variantId) {
      return null;
    }
}

function updateCartUI() {
  return fetch(
    `${routes.cart_url}?sections=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer`,
    { cache: 'no-store' }
  )
    .then(res => res.json())
    .then(sections => {
      // Cart drawer
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.renderContents({
          sections: {
            'cart-drawer': sections['cart-drawer'],
            'cart-icon-bubble': sections['cart-icon-bubble']
          }
        });
      }

      // Cart page items
      const cartItems = document.querySelector('cart-items');
      if (cartItems && sections['main-cart-items']) {
        const html = new DOMParser().parseFromString(
          sections['main-cart-items'],
          'text/html'
        );
        const newItems = html.querySelector('cart-items');
        if (newItems) {
          cartItems.innerHTML = newItems.innerHTML;
        }
      }

      // Cart footer
      const cartFooter = document.querySelector('#main-cart-footer');
      if (cartFooter && sections['main-cart-footer']) {
        const html = new DOMParser().parseFromString(
          sections['main-cart-footer'],
          'text/html'
        );
        const newFooter = html.querySelector('.js-contents-totals');
        if (newFooter) {
          cartFooter.querySelector('.js-contents-totals').innerHTML =
            newFooter.innerHTML;
        }
      }

      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom' });
    });
}

function initOneClickUpsell() {
  const btn = document.querySelector('[data-one-click-upsell]');
  if (!btn || btn.dataset.initialized) return;

  btn.dataset.initialized = 'true';

  btn.addEventListener('click', async (e) => {
    e.preventDefault();

    if (btn.classList.contains('loading')) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) {
      console.error('Missing data-variant-id');
      return;
    }

    const spinner = btn.querySelector('.loading-overlay__spinner');
    btn.classList.add('loading');
    btn.setAttribute("aria-disabled", true);
    if (spinner) spinner.classList.remove('hidden');

    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      const itemPayload = {
        id: Number(variantId),
        quantity: 1,
        properties: {
          _one_click_upsell: 'true'
        }
      };
      const sellingPlanId = btn.dataset.sellingPlanId;
      if (sellingPlanId) {
        itemPayload.selling_plan = Number(sellingPlanId);
      }

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [itemPayload]
        })
      });

      if (!addRes.ok) {
        const errText = await addRes.text();
        throw new Error(errText);
      }

      await updateCartUI();

    } catch (err) {
      console.error('Upsell error:', err);
    } finally {
      btn.classList.remove('loading');
      btn.setAttribute("aria-disabled", false);
      if (spinner) spinner.classList.add('hidden');
    }
  });
}

function initSubscribeAndSave() {
  const btn = document.querySelector('[data-subscribe-save]');
  if (!btn || btn.dataset.initialized) return;
  btn.dataset.initialized = 'true';
  btn.addEventListener('click', async () => {
    if (btn.classList.contains('loading')) return;
    const sellingPlanId = Number(btn.dataset.sellingPlanId);
    if (!sellingPlanId) {
      console.error('Missing selling plan ID');
      return;
    }
    const spinner = btn.querySelector('.loading-overlay__spinner');
    btn.classList.add('loading');
    btn.setAttribute("aria-disabled", true);
    if (spinner) spinner.classList.remove('hidden');
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const itemsToUpgrade = cart.items.filter(item => {
        return !item.selling_plan_allocation;
      });
      // sequential updates
      for (const item of itemsToUpgrade) {
        const payload = {
          id: item.key,
          quantity: item.quantity,
          selling_plan: sellingPlanId
        };
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        if (!res.ok) {
          const err = await res.text();
          console.error(err);
        }
      }
      await updateCartUI();
    } catch (err) {
      console.error('Subscribe & Save error:', err);
    } finally {
      btn.classList.remove('loading');
      btn.setAttribute("aria-disabled", false);
      if (spinner) spinner.classList.add('hidden');

    }
  });
}

function initPurchaseNotifications() {
  const wrapper = document.querySelector('[data-cart-purchase-notification]');

  if (!wrapper) return;

  const messageEl = wrapper.querySelector('[data-purchase-message]');

  const interval = Number(wrapper.dataset.interval) || 10000;

  const jsonEl = document.querySelector('#cart-purchase-data');

  if (!jsonEl) return;

  const data = JSON.parse(jsonEl.textContent);

  const customers = data.customers || [];
  const cities = data.cities || [];
  const products = data.products || [];

  function random(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function renderMessage() {
    const customer = random(customers);
    const city = random(cities);
    const product = random(products);

    const minutes =
      Math.floor(Math.random() * 10) + 1;

    messageEl.innerHTML =
      `<span class="green-dot"></span><strong>${customer} from ${city}</strong> just ordered ${product} · ${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  }

  renderMessage();

  clearInterval(window.purchaseNotificationInterval);

  window.purchaseNotificationInterval =
    setInterval(renderMessage, interval);
}

function initBundleRemove() {
  const btn = document.querySelector('[data-remove-bundle]');
  if (!btn || btn.dataset.initialized) return;

  btn.dataset.initialized = 'true';

  btn.addEventListener('click', async () => {
    const bundleId = btn.dataset.removeBundle;

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const updates = {};

      cart.items.forEach((item, index) => {
        if (item.properties && item.properties._bundle_id == bundleId) {
          updates[index + 1] = 0; // Shopify uses 1-based index
        }
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      await updateCartUI('bundle-remove');

    } catch (err) {
      console.error('Bundle remove error:', err);
    }
  });
}

// Initalize bundle
function initBundleBuilders(scope = document) {
  const builders = scope.querySelectorAll('[data-bundle-builder]');
  builders.forEach(el => {
    if (el.dataset.initialized) return;
    el.dataset.initialized = "true";
    new BundleBuilder(el);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initBundleBuilders();
  initOneClickUpsell();
  initSubscribeAndSave();
  initCartSavedTimer();
  initPurchaseNotifications()
});

if (typeof subscribe === "function" && PUB_SUB_EVENTS?.cartUpdate) {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    setTimeout(() => {
      initBundleBuilders(document);
      initOneClickUpsell(document);
      initCartTabs(document);   
      initSubscribeAndSave(document);
      initCartSavedTimer(document);
      initPurchaseNotifications(document);
    }, 50);
  });
}

/* Cart saved timer */
function initCartSavedTimer() {
  const wrapper = document.querySelector('[data-cart-saved-timer]');
  const display = document.querySelector('[data-cart-saved-timer-display]');

  if (!wrapper || !display) return;

  const STORAGE_KEY = 'cart_reservation_end';
  const DURATION = 5 * 60 * 1000;

  async function ensureTimerStarted() {
    const cart = await fetch('/cart.js').then(r => r.json());

    if (!cart.item_count) {
      sessionStorage.removeItem(STORAGE_KEY);
      wrapper.hidden = true;
      return;
    }

    let endTime = sessionStorage.getItem(STORAGE_KEY);

    if (!endTime) {
      endTime = Date.now() + DURATION;
      sessionStorage.setItem(STORAGE_KEY, endTime);
    }

    wrapper.hidden = false;

    startCountdown(Number(endTime));
  }

  function startCountdown(endTime) {
    function update() {
      const remaining = endTime - Date.now();

      if (remaining <= 0) {
        display.innerHTML = '00:00';
        wrapper.remove();
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }

      const minutes = Math.floor(remaining / 1000 / 60);
      const seconds = Math.floor((remaining / 1000) % 60);

      display.innerHTML =
        `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }

    update();

    clearInterval(window.cartSavedTimerInterval);

    window.cartSavedTimerInterval = setInterval(update, 1000);
  }

  ensureTimerStarted();
}

/* Remove bundle from cart */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-remove-bundle]');
  if (!btn) return;

  e.preventDefault();

  btn.closest('.cart-item').classList.add('disabled');
  btn.closest('.cart-item').querySelector('.loading-overlay').classList.remove('hidden');

  const bundleId = btn.dataset.removeBundle;

  const cart = await fetch('/cart.js').then(r => r.json());

  const updates = {};

  cart.items.forEach(item => {
    if (item.properties?._bundle_id == bundleId) {
      updates[item.key] = 0;
    }
  });

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  });

  await updateCartUI();
});